// Mock city data with coordinates
// In a real application, you would use a geocoding API
export const citiesData = [
    { name: "New York, USA", lat: 40.7128, lng: -74.0060 },
    { name: "Los Angeles, USA", lat: 34.0522, lng: -118.2437 },
    { name: "London, UK", lat: 51.5074, lng: -0.1278 },
    { name: "Paris, France", lat: 48.8566, lng: 2.3522 },
    { name: "Tokyo, Japan", lat: 35.6762, lng: 139.6503 },
    { name: "Sydney, Australia", lat: -33.8688, lng: 151.2093 },
    { name: "Rio de Janeiro, Brazil", lat: -22.9068, lng: -43.1729 },
    { name: "Cairo, Egypt", lat: 30.0444, lng: 31.2357 },
    { name: "Moscow, Russia", lat: 55.7558, lng: 37.6173 },
    { name: "Beijing, China", lat: 39.9042, lng: 116.4074 },
    { name: "Toronto, Canada", lat: 43.6532, lng: -79.3832 },
    { name: "Berlin, Germany", lat: 52.5200, lng: 13.4050 },
    { name: "Rome, Italy", lat: 41.9028, lng: 12.4964 },
    { name: "Madrid, Spain", lat: 40.4168, lng: -3.7038 },
    { name: "Dubai, UAE", lat: 25.2048, lng: 55.2708 },
    { name: "Singapore", lat: 1.3521, lng: 103.8198 },
    { name: "Mumbai, India", lat: 19.0760, lng: 72.8777 },
    { name: "Mexico City, Mexico", lat: 19.4326, lng: -99.1332 },
    { name: "Cape Town, South Africa", lat: -33.9249, lng: 18.4241 },
    { name: "Amsterdam, Netherlands", lat: 52.3676, lng: 4.9041 },
    { name: "Chicago, USA", lat: 41.8781, lng: -87.6298 },
    { name: "Miami, USA", lat: 25.7617, lng: -80.1918 },
    { name: "San Francisco, USA", lat: 37.7749, lng: -122.4194 },
    { name: "Vancouver, Canada", lat: 49.2827, lng: -123.1207 },
    { name: "Montreal, Canada", lat: 45.5017, lng: -73.5673 }
]; 